import { useEffect } from "react";
import UIMenus from "../../components/UIMenus";
import Container from "../../libs/react-phaser-fiber/components/Container";
import Image from "../../libs/react-phaser-fiber/components/Image";
import usePhaser from "../../libs/react-phaser-fiber/hooks/usePhaser";
import CRTFilter from '../../utils/CRTShaderFX'
import { playGlobalScore } from "../../utils/globalScore";

const SplashScreenScene = () => {
  const { scene } = usePhaser();
  useEffect(() => {
    if(scene) {
      scene.cameras.main.setPostPipeline(CRTFilter)

      playGlobalScore(scene)

      scene.navigateToScene = (sceneId, props = {}) => {
        scene.cameras.main.fade(500, 0, 0, 0);
        scene.tweens.add({
          targets: scene.titlesMusic,
          volume: 0,
          ease: "Linear",
          duration: 500,
          onComplete: () => {
            scene.titlesMusic?.pause();
            scene.scene.start(sceneId, props);
          },
        });
      }
    }
  },[scene])
  
  const onBGAddedToScreen = (image) => {
    if(!scene?.cameras?.main) return false
    let scaleX = scene?.cameras?.main.width / image.width;
    let scaleY = scene?.cameras?.main.height / image.height;
    let scale = Math.min(scaleX, scaleY);
    image.setOrigin(0.5, 0.5);
    image.setScale(scale).setScrollFactor(0);
    image.name = "background_art";
    const menu = new UIMenus(scene);
    menu.showInitialMenu();
  };
  return (
    <Container>
      {scene?.cameras?.main && (
        <Image
          args={[
            scene?.cameras?.main?.width / 2,
            scene?.cameras?.main?.height / 2,
            "Cover",
          ]}
          addedToScene={onBGAddedToScreen}
        />
      )}
    </Container>
  );
};
export default SplashScreenScene;
